import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'
import Emoji from 'components_new/atoms/Emoji'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'

import { useTranslation } from 'language/translator'

interface Props {
  sx?: SxProps
}

const Empty = (props: Props) => {
  const { sx } = props
  const { t } = useTranslation()

  return (
    <Box sx={sx}>
      <EmptyPlaceholder
        background={true}
        height={512}
        size="medium"
        title={
          <>
            {t('search', 'no_results_match')} <Emoji name={'mag'} />
          </>
        }
      />
    </Box>
  )
}

export default Empty
